import * as Types from '../../graphql/generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UnresolveInvoiceRunErrorMutationVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;


export type UnresolveInvoiceRunErrorMutation = { __typename?: 'Mutation', unresolveInvoiceRunError: { __typename?: 'InvoiceRunError', id: string, resolved_at?: string | null, resolved_by?: string | null, resolution_note?: string | null } };


export const UnresolveInvoiceRunErrorDocument = gql`
    mutation UnresolveInvoiceRunError($id: UUID!) {
  unresolveInvoiceRunError(id: $id) {
    id
    resolved_at
    resolved_by
    resolution_note
  }
}
    `;
export type UnresolveInvoiceRunErrorMutationFn = Apollo.MutationFunction<UnresolveInvoiceRunErrorMutation, UnresolveInvoiceRunErrorMutationVariables>;

/**
 * __useUnresolveInvoiceRunErrorMutation__
 *
 * To run a mutation, you first call `useUnresolveInvoiceRunErrorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnresolveInvoiceRunErrorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unresolveInvoiceRunErrorMutation, { data, loading, error }] = useUnresolveInvoiceRunErrorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnresolveInvoiceRunErrorMutation(baseOptions?: Apollo.MutationHookOptions<UnresolveInvoiceRunErrorMutation, UnresolveInvoiceRunErrorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnresolveInvoiceRunErrorMutation, UnresolveInvoiceRunErrorMutationVariables>(UnresolveInvoiceRunErrorDocument, options);
      }
export type UnresolveInvoiceRunErrorMutationHookResult = ReturnType<typeof useUnresolveInvoiceRunErrorMutation>;
export type UnresolveInvoiceRunErrorMutationResult = Apollo.MutationResult<UnresolveInvoiceRunErrorMutation>;
export type UnresolveInvoiceRunErrorMutationOptions = Apollo.BaseMutationOptions<UnresolveInvoiceRunErrorMutation, UnresolveInvoiceRunErrorMutationVariables>;